import { useState } from "react";
import { toast } from "sonner";
import { submitEnquiry, formatApiError } from "../lib/api";

const PROJECT_TYPES = [
  "Full home interiors",
  "Villa / penthouse",
  "Modular kitchen",
  "Commercial / office",
  "Renovation",
  "Consultation only",
];

const BUDGETS = [
  "Under ₹25 lakh",
  "₹25L – ₹50L",
  "₹50L – ₹1 crore",
  "Above ₹1 crore",
  "Not sure yet",
];

const initial = {
  name: "",
  email: "",
  phone: "",
  project_type: PROJECT_TYPES[0],
  budget: BUDGETS[0],
  message: "",
};

export default function EnquiryForm({ compact = false }) {
  const [form, setForm] = useState(initial);
  const [sending, setSending] = useState(false);

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const { data } = await submitEnquiry(form);
      toast.success(data.message || "Enquiry received — we will be in touch.");
      setForm(initial);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={onSubmit} data-testid="enquiry-form" className="space-y-7">
      <div className={`grid gap-7 ${compact ? "" : "sm:grid-cols-2"}`}>
        <div>
          <label htmlFor="ef-name" className="field-label">Full name *</label>
          <input
            id="ef-name"
            data-testid="enquiry-name-input"
            className="field"
            placeholder="Aarav Sharma"
            value={form.name}
            onChange={set("name")}
            required
            minLength={2}
          />
        </div>
        <div>
          <label htmlFor="ef-phone" className="field-label">Phone *</label>
          <input
            id="ef-phone"
            data-testid="enquiry-phone-input"
            className="field"
            placeholder="+91 98XXX XXXXX"
            value={form.phone}
            onChange={set("phone")}
            required
            minLength={7}
            maxLength={20}
          />
        </div>
        <div>
          <label htmlFor="ef-email" className="field-label">Email *</label>
          <input
            id="ef-email"
            data-testid="enquiry-email-input"
            type="email"
            className="field"
            placeholder="you@example.com"
            value={form.email}
            onChange={set("email")}
            required
          />
        </div>
        <div>
          <label htmlFor="ef-type" className="field-label">Project type</label>
          <select
            id="ef-type"
            data-testid="enquiry-type-select"
            className="field cursor-pointer"
            value={form.project_type}
            onChange={set("project_type")}
          >
            {PROJECT_TYPES.map((t) => (
              <option key={t}>{t}</option>
            ))}
          </select>
        </div>
        <div className={compact ? "" : "sm:col-span-2"}>
          <label htmlFor="ef-budget" className="field-label">Indicative budget</label>
          <select
            id="ef-budget"
            data-testid="enquiry-budget-select"
            className="field cursor-pointer"
            value={form.budget}
            onChange={set("budget")}
          >
            {BUDGETS.map((b) => (
              <option key={b}>{b}</option>
            ))}
          </select>
        </div>
      </div>

      <div>
        <label htmlFor="ef-message" className="field-label">
          About your space
        </label>
        <textarea
          id="ef-message"
          data-testid="enquiry-message-textarea"
          className="field resize-none"
          rows={compact ? 3 : 4}
          placeholder="A 4BHK in Kondapur, ready possession, warm contemporary look…"
          value={form.message}
          onChange={set("message")}
          maxLength={2000}
        />
      </div>

      <button
        type="submit"
        data-testid="enquiry-submit-button"
        disabled={sending}
        className="btn-bronze w-full disabled:opacity-60 disabled:translate-y-0"
      >
        {sending ? "Sending…" : "Send Enquiry"}
      </button>
    </form>
  );
}
